import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import * as userApi from "../../api/userApi/userApi";
import {EQUser, initializeUser} from "../../models/serverModels/EQUser";
import BoardManagerForm from "./BoardManagerForm";

const UpdateBoardManager = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: Officer, isLoading: isGetLoading} = useGetQuery<ResponseItem<EQUser>>({
    key: ["OfficerList", {token: tokenState, id: parseInt(id!)}],
    api: () => userApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQUser>,
    Params.Update<EQUser>
  >({
    api: userApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/BoardManager`);
        queryClient.invalidateQueries("BoardManagerList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQUser>({defaultValues: initializeUser(5)});

  const {reset} = methods;

  useEffect(() => {
    reset(Officer?.item);
  }, [Officer?.item, reset]);

  const onSubmit: SubmitHandler<EQUser> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...Officer?.item, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="게시판 담당자 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <BoardManagerForm />
            <ConfirmButtonGroup link={`/BoardManager`} cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateBoardManager;
